import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import WishlistOverlay from '@/shared/product/wishlist/ui/WishlistOverlay.vue';
import { provideWishlistApi } from '@/shared/product/wishlist/useWishlistApi';
import { B2CClientService } from '@/b2c/shared/api/server-apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductWishlist',
  setup(__props) {

provideWishlistApi(B2CClientService.getAllWishLists, B2CClientService.createWishListItem, B2CClientService.createWishList);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WishlistOverlay))
}
}

})